export default __webpack_public_path__ + "static/media/maestro.a9e29c62.jpg";